// Liste de feuilletage (Page Up / Page Down entre fiches d'une même liste).
//
// Modèle unique pour les trois domaines, généralisé depuis le mécanisme
// atelier : la page-liste FIGE l'ordre affiché au moment où l'on ouvre une
// fiche, et la fiche dérive sa position de l'URL. Rien n'est compté à la main
// (l'ancien `pgIndex`/`pgLength` du dépannage se désynchronisait dès qu'une
// navigation ne passait pas par les touches).

export const SET_FEUILLETAGE = "SET_FEUILLETAGE"
export const CLEAR_FEUILLETAGE = "CLEAR_FEUILLETAGE"

// `domaine` : "dep" | "ate" | "loc" — `ids` : la liste AFFICHÉE, dans l'ordre
// du tableau ; `source` sert au diagnostic (d'où vient la liste).
export const setFeuilletage = (domaine, ids, source = "") => ({
	type: SET_FEUILLETAGE,
	payload: { domaine, ids: (ids || []).map((id) => parseInt(id)), source },
})

export const clearFeuilletage = (domaine) => ({
	type: CLEAR_FEUILLETAGE,
	payload: { domaine },
})
